<div class="csu-wrapper" [class.csu-wrapper-inline]="renderMode === 'expanded'">
  <div class="csu-content csu-content-disabled" *ngIf="renderMode === 'pill'" aria-hidden="true">
    <ng-content></ng-content>
  </div>

  <button
    *ngIf="renderMode === 'pill'"
    type="button"
    class="csu-pill"
    [class.csu-pill-inline]="pillMode === 'relative'"
    [class.csu-pill-open]="isOpen"
    [attr.data-pos]="pillPosition"
    (click)="toggleOpen()"
    [attr.aria-label]="(isOpen ? 'Close' : 'Open') + ' coming soon details for ' + title"
  >
    <span class="csu-pill-text">Coming Soon</span>
  </button>

  <ng-container *ngIf="renderMode === 'expanded'; else pillModeTpl">
    <div class="csu-card csu-card-inline">
      <ng-container [ngTemplateOutlet]="cardBodyTpl" [ngTemplateOutletContext]="{ canClose: false }"></ng-container>
    </div>
  </ng-container>

  <ng-template #pillModeTpl>
    <div class="csu-overlay" *ngIf="isOpen" role="dialog" aria-modal="true">
      <div class="csu-card" (click)="$event.stopPropagation()">
        <ng-container [ngTemplateOutlet]="cardBodyTpl" [ngTemplateOutletContext]="{ canClose: true }"></ng-container>
      </div>
      <div class="csu-backdrop" (click)="close()"></div>
    </div>
  </ng-template>

  <ng-template #cardBodyTpl let-canClose="canClose">
    <div class="csu-card-top">
      <div class="csu-badge">Coming Soon</div>
      <button *ngIf="canClose" type="button" class="csu-close" (click)="close()" aria-label="Close">
        ✕
      </button>
    </div>

    <div class="csu-header">
      <div class="csu-title" *ngIf="title">{{ title }}</div>
      <div class="csu-desc">{{ description }}</div>
    </div>

    <div class="csu-actions" *ngIf="!isSubmitted; else submittedTpl">
      <button
        type="button"
        class="csu-btn"
        (click)="startInterestSubmission('need')"
        [disabled]="isSubmitting"
      >
        <mat-icon class="csu-btn-icon">thumb_up_off_alt</mat-icon>
        <span>{{ isSubmitting ? 'Submitting...' : 'Yes, prioritize this' }}</span>
      </button>

      <button
        type="button"
        class="csu-btn"
        (click)="startInterestSubmission('curious')"
        [disabled]="isSubmitting"
      >
        <mat-icon class="csu-btn-icon">thumb_down_off_alt</mat-icon>
        <span>Not interested</span>
      </button>

      <button
        *ngIf="allowFeedback && !pendingInterestType"
        type="button"
        class="csu-btn csu-btn-link"
        (click)="toggleCommenting()"
        [disabled]="isSubmitting"
      >
        <mat-icon class="csu-btn-icon">chat_bubble_outline</mat-icon>
        <span>{{ isCommenting ? 'Hide comments' : 'Add comments' }}</span>
      </button>
    </div>

    <div class="csu-error" *ngIf="submitError">{{ submitError }}</div>

    <div class="csu-expanded" *ngIf="isCommenting && allowFeedback && !isSubmitted">
      <div class="csu-field">
        <label class="csu-label">
          {{ commentLabel }}
        </label>
        <textarea
          class="csu-textarea"
          [(ngModel)]="message"
          rows="3"
          [placeholder]="commentPlaceholder"
        ></textarea>
      </div>

      <div class="csu-actions csu-actions-comment">
        <button
          type="button"
          class="csu-btn csu-primary"
          (click)="submitCommenting()"
          [disabled]="isSubmitting"
        >
          {{ commentSubmitLabel }}
        </button>
        <button type="button" class="csu-btn" (click)="cancelCommenting()" [disabled]="isSubmitting">
          Cancel
        </button>
      </div>
    </div>

    <a
      *ngIf="learnMoreHref"
      class="csu-learn"
      [href]="learnMoreHref"
      target="_blank"
      rel="noopener"
    >
      {{ learnMoreLabel }}
    </a>
  </ng-template>
</div>

<ng-template #submittedTpl>
  <div class="csu-submitted">
    <div class="csu-submitted-title">Thanks. We'll keep you posted.</div>
    <div class="csu-submitted-desc">Your interest helps us prioritize what to build next.</div>
  </div>
</ng-template>
